import { Alert, AlertDescription, AlertTitle } from '@ophelos/ui/components/alert';
import { BadgePercent } from 'lucide-react';
import type { ReactNode } from 'react';
import { Countdown } from '@/components/ui/Countdown';

interface DiscountAlertProps {
  title: string;
  /** The "you save …" line, already translated with its amount. */
  saving: ReactNode;
  expiresAt: string | null | undefined;
  className?: string;
}

/** A live offer on a pay page: what it is, what it saves, and when it ends. */
export function DiscountAlert({ title, saving, expiresAt, className }: DiscountAlertProps) {
  return (
    <Alert variant="warning" className={className}>
      <BadgePercent />
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>
        <ul className="list-disc pl-4 space-y-0.5">
          <li>{saving}</li>
          <li>
            <Countdown to={expiresAt} className="text-sm font-normal text-inherit" />
          </li>
        </ul>
      </AlertDescription>
    </Alert>
  );
}
